import { I18n } from '@calendly/i18n'
import { FlexLayout } from '@calendly/ui/components/flex-layout'
import { IconThumbDown } from '@calendly/ui/components/glyphs/IconThumbDown'
import { IconThumbDownFilled } from '@calendly/ui/components/glyphs/IconThumbDownFilled'
import { IconThumbUp } from '@calendly/ui/components/glyphs/IconThumbUp'
import { IconThumbUpFilled } from '@calendly/ui/components/glyphs/IconThumbUpFilled'
import { IconButton } from '@calendly/ui/components/icon-button'
import { CopyIcon } from '@calendly/ui/components/icons'
import { UiIcon } from '@calendly/ui/components/ui-icon'

export const IconButtons = ({ onCopy, onLike, onDislike, isLiked, isDisliked }) => (
  <FlexLayout gap="8">
    <IconButton
      data-testid={isLiked ? 'thumb-up-filled' : 'thumb-up-outline'}
      title={{
        text: I18n.t('publisher.agent_hub.good_response'),
        placement: 'bottom'
      }}
      onClick={onLike}
    >
      <UiIcon icon={isLiked ? IconThumbUpFilled : IconThumbUp} size="medium" />
    </IconButton>
    <IconButton
      title={{
        text: I18n.t('publisher.agent_hub.bad_response'),
        placement: 'bottom'
      }}
      onClick={onDislike}
    >
      <UiIcon icon={isDisliked ? IconThumbDownFilled : IconThumbDown} size="medium" />
    </IconButton>
    <IconButton
      title={{
        text: I18n.t('publisher.agent_hub.copy'),
        placement: 'bottom'
      }}
      onClick={onCopy}
    >
      <CopyIcon />
    </IconButton>
  </FlexLayout>
)
